import React from "react";
import TopRangeFooter from "../components/TopRangeFooter";
import TopRangeContacts from "../components/TopRangeContacts";
import TopRangeNavbarSimple from "../components/TopRangeNavbarSimple";
import TopRangePrivacyNotices from "./legal-notices-sections/TopRangePrivacyNotices";
import ScrollToTop from "../components/ScrollToTop";


function TopRangeLegalNotices() {
  return (
    <>
      <TopRangeNavbarSimple />
      <TopRangePrivacyNotices />
      <TopRangeContacts />
      <TopRangeFooter />
      <ScrollToTop />
    </>
  );
}

export default TopRangeLegalNotices;